import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '@shared/pipes';
import { CarouselVr } from '../carousels';
import { IMediaVr, IVr360, IVrVideo } from '@core/models';

/** Component that displays virtual reality content section */
@Component({
  selector: 'app-section-vr',
  imports: [TranslateModule, CapitalizePipe, CarouselVr],
  templateUrl: './section-vr.html',
  styleUrl: './section-vr.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionVr {
  /** CSS classes applied to the host element */
  @HostBinding('class') class = 'row bg py-3 py-lg-4';
  /** List of virtual reality videos received from parent component */
  readonly vrVideos = input<IVrVideo[]>([]);
  /** List of 360 tours received from parent component */
  readonly vr360 = input<IVr360[]>([]);

  /** Combined list of VR content that interleaves videos and 360 tours */
  protected readonly vrMedia = computed<IMediaVr[]>(() => {
    const vrVideos = this.vrVideos().map((video) => ({ ...video, isVideo: true }));
    const vr360 = this.vr360().map((tour) => ({ ...tour, isVideo: false }));

    const interleaved: IMediaVr[] = [];
    const maxLength = Math.max(vrVideos.length, vr360.length);
    for (let i = 0; i < maxLength * 2; i++) {
      if (i % 2 === 0 && vr360[Math.floor(i / 2)]) {
        interleaved.push(vr360[Math.floor(i / 2)]);
      } else if (i % 2 === 1 && vrVideos[Math.floor(i / 2)]) {
        interleaved.push(vrVideos[Math.floor(i / 2)]);
      }
    }
    return [...interleaved];
  });
}
